﻿// test for any IE and give the user an alert accordingly
if (document.documentMode) {
    var tag = document.createElement('div'),
        warningHtml = '<div class="content"><button type="button" class="btn-icon" onclick="javascript: document.querySelector(\'#ie-warning\').style.display = \'none\';">X</button><p>OK\'s administrations portaler har funktionalitet som ikke understøttes af din browser. Vi kan ikke garantere, at du kan bruge alle funktionaliteterne på sitet. <br />Vi anbefaler at du gør brug af f.eks. <a href="https://www.google.dk/intl/da/chrome/" title="Hent Google Chrome" target="_blank">Google Chrome</a></p><p class="align-right"><i>OK\'s Applikations Team</i></p></div>';

    tag.id = "ie-warning";
    tag.innerHTML = warningHtml;

    document.getElementsByTagName('body')[0].appendChild(tag);

    setTimeout(function () {
        document.querySelector('#ie-warning').classList.add('open');
    }, 500);
}